/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Pos_Pending_Payment_BadgeInputs */

const vi_pos_pending_payment_badge = /** @type {(inputs: Pos_Pending_Payment_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chờ thanh toán đơn ${i?.code}`)
};

/**

* @param {Pos_Pending_Payment_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_pending_payment_badge = /** @type {((inputs: Pos_Pending_Payment_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Pending_Payment_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_pending_payment_badge(inputs)
});